module.exports = __webpack_public_path__ + "img/1549020475.a0c600a2.jpg";